export const styles: { [key: string]: React.CSSProperties } = {
  returnHomeBtn: {
    position: "absolute",
    bottom: "10px",
    right: "10px",
    color: "white",
    zIndex: 3,
  },
};
